module.exports = __webpack_public_path__ + "static/media/herramienta-verde.ebe61a24.svg";